import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { slug: String, source: String }

  connect() {
    this.capture("party_place_collection_viewed")
  }

  select(event) {
    const invitationSlug = event.currentTarget.closest("[data-invitation-slug]")?.dataset.invitationSlug
    this.capture("party_place_invitation_selected", { invitation_slug: invitationSlug })
  }

  browseAll() {
    this.capture("party_place_all_invitations_clicked")
  }

  capture(event, properties = {}) {
    if (typeof window.posthog?.capture !== "function") return

    window.posthog.capture(event, {
      party_place_slug: this.slugValue,
      entry_source: this.sourceValue,
      ...properties
    })
  }
}
